import BaseService from '../core/service/BaseService';
import Mapper from '../core/service/Mapper';
import { isEmpty } from '../core/utils/ValidForm';

const url = 'propostas';
class PropostaIndicadorService extends BaseService {
    async beforeSave({ registro }) {
        const { responsavelIndicador, desdobramento, ...rest } = registro;
        let subtipoIndicador = desdobramento?.id ? { id: desdobramento?.id } : null;
        if (!rest?.tipoIndicador?.id) {
            subtipoIndicador = null;
        }
        const data = JSON.stringify({
            ...rest,
            responsavel: responsavelIndicador?.idenPessoa ? responsavelIndicador : null,
            subtipoIndicador,
        });

        return { data, config: {} };
    }

    async remover({ id }) {
        await window.$http.delete(`${url}/${id}`);
        return '';
    }

    getPesquisarUrl(pagination) {
        return { url: `${url}/find-all`, pagination };
    }

    async saveDadosComplementares(idProposta, dados) {
        const formData = new FormData();
        const { arquivoMetodologiaCalculo, fontes, ...rest } = dados;

        formData.append(
            'request',
            new Blob(
                [
                    JSON.stringify(
                        Mapper.setNullInEmpty({
                            ...rest,
                            fontes: fontes
                                .filter((fonte) => !fonte?.id)
                                .map((fonte) => ({ descFonte: fonte })),
                        })
                    ),
                ],
                {
                    type: 'application/json',
                }
            )
        );
        formData.append(
            'file',
            !isEmpty(arquivoMetodologiaCalculo) ? arquivoMetodologiaCalculo : null
        );

        const response = await window.$http.patch(
            `${url}/dados-complementares/${idProposta}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        return response;
    }

    async saveSerieHistorica(idProposta, { historicoPropostas, ...dados }) {
        const formatDate = (data) => {
            const [dia, mes, ano] = data.split('/');
            return `${ano}-${mes}-${dia}T00:00:00`;
        };
        const response = await window.$http.patch(`${url}/serie-historica/${idProposta}`, {
            ...Mapper.setNullInEmpty(dados),
            historicoPropostas: Mapper.setNullInEmpty(
                historicoPropostas.map(
                    ({ dataReferencia, dataApuracao, valorApurado, ...rest }) => ({
                        ...rest,
                        valorApurado,
                        dataReferencia: formatDate(dataReferencia),
                        dataApuracao: formatDate(dataApuracao),
                    })
                )
            ),
        });
        return response;
    }

    async getDadosComplementares(idProposta, form) {
        const response = await window.$http.get(`${url}/dados-complementares/${idProposta}`);
        return this.getMapper().formatToInput(response.data, form);
    }

    async getSerieHistorica(idProposta) {
        const response = await window.$http.get(`${url}/serie-historica/${idProposta}`);
        return response.data;
    }

    async cancelarProposta({ idProposta, motivo }) {
        return window.$http.patch(`${url}/cancelar/${idProposta}`, { motivoCancelamento: motivo });
    }

    async enviarAnaliseNegocial(idProposta) {
        const response = await window.$http.patch(`${url}/enviar-analise-negocial/${idProposta}`);
        return response.data;
    }

    async getRelatorioProposta(idProposta) {
        const response = await window.$http.get(
            `${url}/relatorios/proposta-indicador/${idProposta}`,
            {
                responseType: 'blob',
            }
        );
        return response.data;
    }

    async getRelatorioResumoProposta(idProposta) {
        const response = await window.$http.get(
            `${url}/relatorios/proposta-alteracao-indicador/${idProposta}`,
            {
                responseType: 'blob',
            }
        );
        return response.data;
    }
}

export default new PropostaIndicadorService(url, 'idProposta', [{ field: 'id', order: 'desc' }]);
